module.exports = __webpack_public_path__ + "img/teacher_img4.96d1334e.png";